const INITIAL_PAGE = 1

export default INITIAL_PAGE
